import XSummaryView from './XSummaryView'

export default XSummaryView
export { XSummaryView }
